import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './SharedStyles.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-page">
      <header className="app-nav">
        <nav className="app-nav-content">
          <Link to="/" className="app-logo">
            Pfändungstabelle API
          </Link>
          <div className="app-nav-links">
            <Link to="/" className="app-nav-link">
              ← Zurück zur Startseite
            </Link>
          </div>
        </nav>
      </header>

      <main className="app-main">
        <div className="app-container-form">
          <form className="app-form" onSubmit={handleSubmit}>
            {error && (
              <div className="app-alert app-alert-error">
                {error}
              </div>
            )}

            <div className="app-form-group">
              <label htmlFor="email" className="app-label">
                E-Mail-Adresse
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="app-input"
                placeholder="ihre@email.de"
              />
            </div>

            <div className="app-form-group">
              <label htmlFor="password" className="app-label">
                Passwort
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="app-input"
                placeholder="Ihr Passwort"
              />
            </div>

            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="app-checkbox"
                />
                <label htmlFor="remember-me" style={{ color: 'var(--text-dark)' }}>
                  Angemeldet bleiben
                </label>
              </div>

              <Link
                to="/forgot-password"
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  color: 'var(--accent-blue)', 
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                Passwort vergessen?
              </Link>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="app-button app-button-primary app-button-full"
            >
              {loading ? (
                <>
                  <span className="app-loading"></span>
                  <span style={{ marginLeft: '0.5rem' }}>Wird angemeldet...</span>
                </>
              ) : (
                'Anmelden'
              )}
            </button>

            <div style={{ margin: '2rem 0', textAlign: 'center', position: 'relative' }}>
              <div style={{ 
                position: 'absolute', 
                top: '50%', 
                left: 0, 
                right: 0, 
                height: '1px', 
                background: 'var(--border-light)' 
              }}></div>
              <span style={{ 
                background: 'var(--background-white)', 
                padding: '0 1rem', 
                color: 'var(--text-light)',
                position: 'relative'
              }}>
                Oder
              </span>
            </div>

            <Link
              to="/register"
              className='app-button app-button-secondary app-button-full'>
              Erstellen Sie ein neues Konto
            </Link>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Login;
